module.exports = __webpack_public_path__ + "static/media/brus-b.e80be3b9.mp3";